export const convertBase64ToObject = (value) => {
    try {
        const decodedValue = [...window.atob(value)];
        const mappedValue = decodedValue.map((c) => {
            const codePoint = c.codePointAt(0);
            if (codePoint === undefined)
                return;
            return '%' + ('00' + codePoint.toString(16)).slice(-2);
        });
        return JSON.parse(decodeURIComponent(mappedValue.join('')));
    }
    catch {
        return {};
    }
};
export const convertJwtToBase64 = (jwt) => {
    return jwt.toString().split('.')[1].replace('-', '+').replace('_', '/');
};
export function isJWTToken(token) {
    const JWT_REGEX = /^(?:[\w=-]+\.){2}[\w+./=-]+$/;
    return JWT_REGEX.test(token);
}
